import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CONFIRM_GENERIC_ERROR } from '@constants/cambio-via-pago-properties.constants';
import { RIGHT_COLUMN_DATA, RUTAS_TRACKING } from '@constants/tramite-pension-constant';
import { INICIO, ROUTING_ESTADO_TRAMITE_PENSION } from '@constants/url.constant';
import { IEstadoTramitePensionResponse } from '@interfaces/estado-tramite-pension.response.interface';
import { StorageService } from '@services/storage/storage.service';
import { IRightColumnData } from '@shared/common/interfaces/right-column-data.interface';
import { Util } from '@shared/common/utils/util';
import { GenericErrorOps } from '@shared/components/generic-error/interfaces/generic-error-ops.interface';
import { Subscription } from 'rxjs/internal/Subscription';
import { EstadoTramitePensionService } from '../../services/estado-tramite-pension.service';

@Component({
  selector: 'app-estado-tramite-pension-home',
  templateUrl: './estado-tramite-pension-home.component.html',
  styleUrls: ['./estado-tramite-pension-home.component.scss'],
  standalone: false
})
export class EstadoTramitePensionHomeComponent implements OnInit, OnDestroy {
  @ViewChild('tituloEstadoTramitePensionElement') tituloEstadoTramitePensionElement!: ElementRef;


  showComponent: boolean = true;
  showErrorScreen: boolean = false;
  isMobile: boolean = false;
  isOpenHelp: boolean = false;
  loadingHome: boolean = true;
  servsError: boolean = false;
  token: string = '';
  public errorOps: GenericErrorOps = CONFIRM_GENERIC_ERROR;
  attempt: boolean = false;
  nAttempts: number = 1;
  etapa: number;

  rightColumnData: IRightColumnData[];
  private routerSubscription: Subscription;

  constructor(private readonly router: Router,
    private readonly estadoTramitePensionService: EstadoTramitePensionService,
    private readonly util: Util,
    private readonly storageService: StorageService,
  ) { }

  ionViewWillEnter(): void {
    this.initializeComponent();
  }

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && event.urlAfterRedirects.includes('estado-tramite-pension')) {
        this.initializeComponent();
      }
    });
  }

  private initializeComponent(): void {
    this.loadingHome = true;
    this.isMobile = window.innerWidth <= 839;
    void this.getEstadoTramitePension();
  }

  async getEstadoTramitePension() {
    try {
      this.attempt = true;
      this.token = await this.util.getIdToken();
      const response: IEstadoTramitePensionResponse = await this.estadoTramitePensionService.getCacheEstadoTramitePensionVejezNormal(
        this.storageService,
        this.token
      );

      const dataTracking = response?.data;
      if (dataTracking && typeof dataTracking.etapa === 'number') {
        this.etapa = dataTracking.etapa;
        const etapaResponse = RUTAS_TRACKING.find((_, index) => index === (dataTracking.etapa - 1));

        this.rightColumnData = dataTracking.etapa === 4 ? [] : [RIGHT_COLUMN_DATA[(dataTracking.etapa - 1)]];

        this.showComponent = true;
        this.loadingHome = false;
        this.servsError = false;

        this.router.navigate([ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_BASE, ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_URL,
        ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_HOME,
          etapaResponse
        ]);

      } else {
        this.handleErrorState()
      }
    } catch (error) {
      console.error('Error al obtener el estado del trámite de pensión:', error);
      this.handleErrorState()
    }
  }

  scrollTo(item: string) {
    const element = document.getElementById(item);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    } else {
      console.warn('Elemento no encontrado:', item);
    }
  }

  navigateTo(destination: string[]) {
    this.router.navigate(destination);
  }

  toggleHelp() {
    this.isOpenHelp = !this.isOpenHelp;
  }

  preguntasFrecuentes() {
    const element = document.getElementById('faqElement');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    } else {
      console.warn('faqElement no está definido.');
    }

  }

  goToVideoAtencion() {
    this.router.navigate(['video-atencion']);
  }

  onGoToEvent() {
    this.router.navigate([INICIO]);
  }
  private handleErrorState() {
    this.showComponent = false;
    this.loadingHome = true;
    this.servsError = true;
    this.attempt = false;
  }

  onRetryEvent() {
    this.attempt = true;
    this.nAttempts++;
    if (this.nAttempts <= 3) {
      void this.getEstadoTramitePension();
    } else {
      this.router.navigate([INICIO]);
    }
  }

  get isEtapa(): boolean {
    return (this.etapa !== 4 && this.etapa !== 5);
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isMobile = window.innerWidth <= 839;
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
